import clsx from 'clsx'
import { Icon } from '@iconify/react'
import { Button } from '@pepper/ui'

import ThemesError from 'assets/images/content-ideas/themes-error.png'

import s from './ErrorState.module.css'

type Props = {
  onRefetch: () => void
  isLoading?: boolean
  className?: string
}

export const ErrorState = ({ onRefetch, isLoading, className }: Props) => {
  return (
    <div className={clsx(s.wrapper, className)}>
      <div className={s.body}>
        <img src={ThemesError} alt="themes-error" />
        <div className={s.title}>Something went wrong! </div>
        <div className={s.description}>
          We were unable to fetch content themes
        </div>
        <Button
          type="ghost"
          icon={<Icon icon="radix-icons:reload" />}
          iconPlacement="right"
          onClick={onRefetch}
          loading={isLoading}
        >
          Retry
        </Button>
      </div>
    </div>
  )
}
